
import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import QuickOrder from './components/QuickOrder';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <QuickOrder />
      <Services />
      <Contact />
      <Footer />
    </div>
  );
}
